import { IComment } from '@app/models/Comment'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Link } from 'react-router-dom'

interface ICommentItemHeaderProps {
  beginEdit: (feedItemId: string, commentId: string) => void
  deleteComment: (feedItemId: string, commentId: string) => void
  item: IComment
}

type CommentItemHeaderProps = ICommentItemHeaderProps & ICurrentUserState

export default class CommentItemHeader extends React.PureComponent<
  CommentItemHeaderProps
> {
  constructor(props: CommentItemHeaderProps) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='comment-item-header'>
        <Link
          className='font-weight-bold'
          to={`/connection/${this.props.item.author.contactId}`}
        >
          {this.props.item.author.name}
        </Link>
        {this.props.item.isEditing
          ? this._renderEditMode()
          : this._renderViewMode()}
      </div>
    )
  }

  private _canDelete() {
    return (
      this.props.user &&
      (this.props.user.id === this.props.item.author.contactId ||
        this.props.user.permissions.isAdmin === true)
    )
  }

  private _canEdit() {
    return (
      this.props.user && this.props.user.id === this.props.item.author.contactId
    )
  }

  private _deleteComment() {
    this.props.deleteComment(this.props.item.parentId, this.props.item.id)
  }

  private _editComment() {
    this.props.beginEdit(this.props.item.parentId, this.props.item.id)
  }

  private _renderEditMode() {
    return <span className='ml-2 small text-muted'>(editing)</span>
  }

  private _renderViewMode() {
    return (
      <span>
        {this.props.item.isEdited && (
          <span className='ml-2 small text-muted'>(edited)</span>
        )}
        {this._canEdit() && (
          <a
            className='ml-1 px-1 small'
            onClick={this._editComment}
            title='Edit'
          >
            <FontAwesomeIcon icon={['far', 'pencil']} fixedWidth />
          </a>
        )}
        {this._canDelete() && (
          <a
            className='ml-1 px-1 small'
            onClick={this._deleteComment}
            title='Delete'
          >
            <FontAwesomeIcon icon={['far', 'trash']} fixedWidth />
          </a>
        )}
      </span>
    )
  }
}
